import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import ScrollableTemplate from './ScrollableTemplate.js';

var _excluded = ["children"];
var createTemplate = function createTemplate(styleClass) {
  return function (_ref) {
    var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/React.createElement(ScrollableTemplate, _extends({
      styleClass: styleClass
    }, props), children);
  };
};
var Scrollable = {
  Wrapper: createTemplate('scrollableWrapper'),
  Header: createTemplate('scrollableHeader'),
  Container: createTemplate('scrollableContainer')
};

export { Scrollable as default };
//# sourceMappingURL=index.js.map
